// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__aC4W0","colBig":"styles_colBig__18wDe","colSmall":"styles_colSmall__7VO4L"};